import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  useTheme as useMuiTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import Sidebar from "../sideNav/Sidebar";
import { useTheme } from "../../contexts/ThemeContext";

const drawerWidth = 240;
const drawerWidthCompact = 70;

const DashboardLayout: React.FC = () => {
  const muiTheme = useMuiTheme();
  const { darkMode } = useTheme();
  const isMobile = useMediaQuery("(max-width: 360px)");
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [compactMode, setCompactMode] = useState(false);

  // Responsividade automática da sidebar
  useEffect(() => {
    setCompactMode(isSmallScreen);
  }, [isSmallScreen]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      {/* AppBar para mobile */}
      <AppBar
        position="fixed"
        sx={{
          display: isMobile ? "flex" : "none",
          width: "100%",
          zIndex: muiTheme.zIndex.drawer + 1,
          backgroundColor: "#332F30",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Portal de Vagas
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Sidebar - Desktop */}
      <Drawer
        variant="permanent"
        sx={{
          display: isMobile ? "none" : "block",
          width: compactMode ? drawerWidthCompact : drawerWidth,
          transition: "width 0.3s ease-in-out",
          "& .MuiDrawer-paper": {
            width: compactMode ? drawerWidthCompact : drawerWidth,
            boxSizing: "border-box",
            borderRight: "none",
            backgroundColor: "#332F30",
            backgroundImage: "none",
            position: "fixed",
            height: "100vh",
            top: 10,
            left: 0,
            borderRadius: "0 20px 20px 0",
            boxShadow: "2px 0 10px rgba(0,0,0,0.3)",
            overflow: "visible",
            transition: "width 0.3s ease-in-out",
          },
        }}
      >
        <Sidebar
          onItemClick={() => {}}
          compactMode={compactMode}
          setCompactMode={setCompactMode}
        />
      </Drawer>

      {/* Sidebar - Mobile */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        sx={{
          display: isMobile ? "block" : "none",
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            backgroundColor: "#332F30",
            borderRadius: "0 20px 20px 0",
            height: "100vh",
            boxShadow: "2px 0 10px rgba(0,0,0,0.3)",
          },
        }}
      >
        <Sidebar
          onItemClick={handleDrawerToggle}
          compactMode={false}
          setCompactMode={() => {}}
        />
      </Drawer>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          p: 0,
          width: "100%",
          pl: isMobile
            ? 0
            : compactMode
            ? `${drawerWidthCompact}px`
            : `${drawerWidth}px`,
          transition: "padding-left 0.3s ease-in-out",
          pt: isMobile ? 8 : 0, // Padding top para mobile (AppBar)
          backgroundColor: darkMode ? "#121212" : "#f5f5f5",
          minHeight: "100vh",
          backgroundImage: darkMode
            ? "radial-gradient(circle at 20% 80%, #1a1a1a 0%, transparent 50%), radial-gradient(circle at 80% 20%, #1a1a1a 0%, transparent 50%)"
            : "radial-gradient(circle at 20% 80%, #eeeeee 0%, transparent 50%), radial-gradient(circle at 80% 20%, #eeeeee 0%, transparent 50%)",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;
